import React from "react";
import { FreelanceNavMain } from "./FreelancerProfileComponents/FreelanceNavMain";
import { MainFreelanceSheduled } from "./FreelanceSheduled/MainFreelanceSheduled";

export const FreelancerSheduled = () => {
  return (
    <view>
      <FreelanceNavMain />
      <MainFreelanceSheduled />
    </view>
  );
};
